// TODO documentation
const VENDOR_TO_HOSTNAME = {
  srf: 'srf',
  rsi: 'rsi',
  rtr: 'rtr',
  rts: 'rts',
  swi: 'play.swissinfo',
};

class PlayPortal {
  static redirectUrl({ id, vendor, mediaType }) {
    const hostName = PlayPortal.getHostNameByVendor(vendor);
    const type = PlayPortal.getPlayMediaType(mediaType);

    if (!hostName) {
      return undefined;
    }
    return `${hostName}/play/${type}/redirect/detail/${id}`;
  }

  static embedUrl({ urn, vendor }) {
    const hostName = PlayPortal.getHostNameByVendor(vendor);

    if (!hostName) {
      return undefined;
    }
    return `${hostName}/play/embed?urn=${urn}`;
  }

  /**
   * Get BU's hostname by vendor
   * @param {String} vendor
   * @returns {String}
   */
  static getHostNameByVendor(vendor) {
    if (!vendor) {
      return undefined;
    }

    const bu = VENDOR_TO_HOSTNAME[vendor.trim().toLowerCase()];
    const subdomain = bu && bu.indexOf('.') < 0 ? 'www.' : '';

    return `https://${subdomain}${bu}.ch`;
  }

  /**
   * Get Play media type
   * @param {String} mediaType
   * @returns {String}
   */
  static getPlayMediaType(mediaType) {
    if (mediaType === 'VIDEO') {
      return 'tv';
    }

    if (mediaType === 'AUDIO') {
      return 'radio';
    }

    // TODO ?
    return undefined;
  }

  /**
   * Generate the Play URL from a given subdivision
   * @param {Subdivision} subdivision
   * @returns {String}
   */
  static redirectUrlFromSubdivision(subdivision) {
    const hostName = PlayPortal.getHostNameByVendor(subdivision.vendor);
    const mediaType = PlayPortal.getPlayMediaType(subdivision.mediaType);
    const { id } = subdivision;

    if (!hostName) {
      return undefined;
    }
    return `${hostName}/play/${mediaType}/redirect/detail/${id}`;
  }
}

export default PlayPortal;
